module.exports = __webpack_public_path__ + "img/chatbot4.f1a60633.svg";